import * as types from './action-types';

export function updateCamera(e){
  return {
    type: types.UPDATE_CAMERA,
    position: e.position,
    quaternion: e.quaternion,
  }
}

export function updateHoveredLayer(payload) {
  return {
    type: types.UPDATE_HOVERED_LAYER,
    layer: payload
  }
}

export function fetchResins(payload) {
  return  {
    type: types.FETCH_RESINS,
    payload
  }
}

export function fetchResinsFullfilled(resins) {
  return {
    type: types.FETCH_RESINS_FULFILLED,
    payload: resins 
  }
}

export function initStackup(spec) {
  return {
    type: types.INIT_STACKUP,
    payload: spec,
  };
}

export function restoreStackup(stackup) {
  return {
    type: types.RESTORE_STACKUP,
    payload: stackup
  };
}

export function addLayer(spec) {
  return {
    type: types.ADD_LAYER,
    payload: spec
  }
}

export function updateLayer(index, payload) {
  return {
    type: types.UPDATE_LAYER,
    index, payload
  }
}

export function deleteLayers(indexi) {
  return {
    type: types.DELETE_LAYERS,
    payload: indexi
  }
}

export function clearStartNewForm() {
  return {
    type: types.CLEAR_START_NEW_FORM,
  }
}

export function updateStartNewForm(key, value){
  return {
    type: types.UPDATE_START_NEW_FORM,
    key,
    value
  }
}

export function saveStackup(payload) {
  return {
    type: types.SAVE_STACKUP,
    payload
  }
}

export function saveStackupFulfilled(payload) {
  return {
    type: types.SAVE_STACKUP_FULFILLED,
    payload
  }
}

export function saveStackupRejected(payload) {
  return {
    type: types.SAVE_STACKUP_REJECTED,
    payload
  }
}

export function updateCalculation(payload) {
  return {
    type: types.UPDATE_CALCULATIONS,
    payload 
  }
}

export function updateCalculationFulfilled(payload) {
  return {
    type: types.UPDATE_CALCULATIONS_FULFILLED,
    payload
  }
}

export function updateCalculationRejected(payload) {
  return {
    type: types.UPDATE_CALCULATIONS_REJECTED,
    payload
  }
}

export function triggerCalculations() {
  return {
    type: types.TRIGGER_CALCULATIONS
  };
}

export function updateCalculationDisplayMhz(payload) {
  return {
    type: types.UPDATE_CALCULATIONS_DISPLAY_MHZ,
    payload
  }
}

export function restoreCalculations(payload) { 
  return {
    type: types.RESTORE_CALCULATIONS,
    payload
  };
}

export function updatePreference(payload) {
  return {
    type: types.UPDATE_PREFERENCE,
    payload
  }
}



// WEBPACK FOOTER //
// ./src/actions/index.js